import { Image, Info } from 'components';

export default function ConfidenceLevelInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person standing on top of a level giving a thumbs up" path="confidence-level.png" title="Confidence Level" />
        <h5>Confidence Level</h5>
        <p>
            This is an advanced feature. The <span className="fst-italic">Confidence Level</span> represents how certain you are that your results are really within the <span className="fst-italic">Margin of Error</span>.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If a survey shows that between 20% and 30% of people like horror movies with a confidence of 95%, then we are very certain. If we run the same experiment again, we would expect the result 19 out of 20 times to be within 20% and 30%.
            <br/>
            <br/>
            If you use a 50% confidence, you are about as confident as winning a coin toss. If you use a 99.999999% <span className="fst-italic">Confidence Level</span>, that is enough to plan a trip to space.
            <br/>
            <br/>
            <span className="text-error">Note</span>: If you&apos;re not sure what this means, keep this set to 95%.
        </p>
    </Info>;

}